import React, { Suspense } from 'react';

const SearchHistory = React.lazy(() => import(/* webpackChunkName: "SearchHistory" */ './SearchHistory'));

export default class SearchHistoryLoader {
    constructor(config) {
        this.config = this._parseConfiguration(config);
    }

    getComponent() {
        const component = <SearchHistory {...this.config} />;

        return <Suspense fallback={<div className="search-history__skeleton">Loading...</div>}>{component}</Suspense>;
    }

    _parseConfiguration(config) {
        return {
            storageKey: 'PNP-SEARCH-HISTORY',
            ...config,
        };
    }
}
